export default __webpack_public_path__ + "static/media/emoji.8521eed0.svg";